exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n.required-field > label[data-v-6f0ab63c]::after {\n    content: '*';\n    color: red;\n    margin-left: 0.25rem;\n}\n.form-control-feedback[data-v-6f0ab63c] {\n    font-weight: 100;\n    color: red;\n    position: initial;\n    text-align: left;\n    height: auto;\n    width: auto;\n}\n.has-danger[data-v-6f0ab63c] {\n    color: red\n}\n.mt[data-v-6f0ab63c] {\n    margin-top: 7px;\n}\n.gradientbt[data-v-6f0ab63c]{\n    background: #0F6940;\n    color: white\n}\n.box-body[data-v-6f0ab63c] {\n    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"id":"data-v-6f0ab63c","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/views/trip/TripCreate.vue
// module id = 194
// module chunks = 0